module.exports = __webpack_public_path__ + "static/media/template-3.f5e38e5b.svg";